const axios = require("axios");

export const localRequest = axios.create({
  baseURL: "http://192.168.4.1",
  timeout: 20000,
});

export const getRequest = async (url, param) => {
  return new Promise(async (resolve, reject) => {
    try {
      url = param ? `${url}/?${param}` : url;
      const { data } = await localRequest.get(url);
      resolve(data);
    } catch (error) {
      error.message = error.response
        ? error.response.data.error
        : error.message;
      reject(error);
    }
  });
};

export const postRequest = (url, body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await localRequest.post(`${url}`, body);
      resolve(data);
    } catch (error) {
      error.message = error.response
        ? error.response.data.error
        : error.message;
      reject(error);
    }
  });
};
